import { ExpandableBlockItem } from '@modules/Nzo.CMS/Frontend/libraries/cmsPage/blocks/blocks.state'
import { BlocksView } from '@modules/Nzo.CMS/Frontend/libraries/cmsPage/blocks/blocks.template'
import { useInView } from '@shared/Frontend/hooks/useInView'
import { pushDatalayer } from '@shared/Frontend/seo/datalayer'
import { cn } from '@shared/Frontend/utils/addToClassName'
import { slugify } from '@shared/Frontend/utils/slugify'
import React from 'react'
import { BlockActions } from '../shared/blockActions'
import { BlockHeader } from '../shared/blockHeader'
import { NestedBlocks } from '../shared/nestedBlocks/nestedBlocks'
import { SVGIcon } from '@shared/Frontend/utils/svg'

export const ExpandableBlock: BlocksView['ExpandableBlock'] = (props) => {
  const { id, items, printMode } = props
  if (items?.length == 0) return <></>
  const { inView, ref } = useInView({ threshold: 0.1 })
  return (
    <section id={id} ref={ref} className={cn('block block--list block--expand ls-spacing', inView && 'inview')}>
      <div className="block__inner ls-container ls-gutter gridsys--columns">
        <BlockHeader {...props} headerClassName='gridsys--50p' />

        <div className="block__content gridsys--50p">
          <div className='expands block__list'>
            {items.map((item, index) => (
              <ItemLayout key={index} id={`expandable-${slugify(item.title)}`} item={item} isPrintMode={printMode}>
                <NestedBlocks nestedBlocks={item.nestedBlocks} {...props} />
              </ItemLayout>
            ))}
          </div>
          <BlockActions {...props} datalayerCategory="expandable_block" />
        </div>
      </div>
    </section>
  )
}

const ItemLayout = (props: {
  id: string
  item: ExpandableBlockItem
  children?: React.ReactNode
  isPrintMode: boolean
  className?: string
}): JSX.Element => {
  const { id, item, isPrintMode, children, className } = props
  const [open, setOpen] = React.useState<boolean>(false)

  return (
    <details
      className={cn('expand', className)}
      open={open || isPrintMode}
      onToggle={(e) => {
        if (!isPrintMode) {
          setOpen(e.currentTarget.open)
          if (e.currentTarget.open) {
            pushDatalayer({
              category: 'expandable_block',
              label: item.title,
              action: 'open_item',
            })
          }
        }
      }}
    >
      <summary id={id} className="expand__summary">
        <div className="expand__text">
          <p className="expand__title title--xs">{item.title}</p>
          {item.description && <p className="expand__description text--sm">{item.description}</p>}
          {true ? (
            <SVGIcon className='expand__icon' id="icon-chevron-down" size={20} />
          ) : (
            <div className='expand__icon'>
              <span className='expand__iconline'></span>
              <span className='expand__iconline'></span>
            </div>
          )}
        </div>
      </summary>

      <div className="expand__body">
        {item.body && <div className="expand__content text--styled" dangerouslySetInnerHTML={{ __html: item.body }} />}
        {children && <div className="expand__blocks">{children}</div>}
      </div>
    </details>
  )
}
